import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.04 22.04v-2.435a.79.79 0 0 0-.79-.794H7.813v-7.619h2.437c.438 0 .79-.356.79-.794v-2.73h7.92v2.73c0 .438.352.794.79.794h2.438v7.619H19.75a.79.79 0 0 0-.79.794v2.434zm-1.584 3.227H4.584v-4.869h4.872zM4.584 4.736h4.872v4.869H4.584zm15.96 0h4.872v4.869h-4.872zm4.872 20.531h-4.872v-4.869h4.872zm-5.666 1.585h6.456A.79.79 0 0 0 27 26.06v-6.456a.795.795 0 0 0-.794-.794h-2.434v-7.619h2.434a.795.795 0 0 0 .794-.794V3.942a.795.795 0 0 0-.794-.794H19.75a.79.79 0 0 0-.79.794V6.08h-7.92V3.942a.79.79 0 0 0-.79-.794H3.79a.794.794 0 0 0-.79.794v6.456c0 .438.356.794.79.794h2.438v7.619H3.791a.794.794 0 0 0-.791.794v6.456c0 .437.356.79.79.79h6.46a.79.79 0 0 0 .79-.79v-2.438h7.92v2.438c0 .437.352.79.79.79"
    }, null, -1)
  ]))]))
}
export default { render: render }